module.exports = __webpack_public_path__ + "static/media/about.61586ca6.png";